export const SIGNUP_MODAL_EVENTS = {
  RENDERED: 'UserAccount.SignupModalRendered',
  FALLBACK_USED: 'UserAccount.SignupModalFallbackUsed',
  CTA_CLICKED: 'UserAccount.SignupModalCtaClicked',
} as const
